var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account"},[_c('ul',{staticClass:"pub_nav"},[_c('li',{class:{active:_vm.$route.path.indexOf('/personal_center/safe')>-1}},[_c('a',[_vm._v("账号安全")])])]),_c('div',{staticClass:"box"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }